import { isInteger } from 'lodash';

/**
 * @returns value with number only (if not number or below 0, return 0)
 */

export function numberOnly(value) {
  return isInteger(+value) ? +value : 0;
}

/**
 * @returns value for price number parser
 */

export const priceInputNumberParser = (value) => {
  return value.replace(/[^0-9]\s?|(\.*)/g, '').replace(/^0+/, '');
};

/**
 * @returns value with IDR price format
 */

export const priceInputNumberFormatter = (value) => {
  return `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

/**
 * @returns value with %
 */

export const percentageInputNumberParser = (value) => {
  return value.replace(/[^0-9]\s?|(\.*)/g, '');
};

/**
 * @returns value with %
 */

export const percentageInputNumberFormatter = (value) => {
  return `${value} %`;
};
